module.exports = __webpack_public_path__ + "img/header.7c2b9435.jpg";